export default __webpack_public_path__ + "static/media/security.f9e45b56.png";